import { memoize } from "lodash";
import { utilBalancing } from "../utils/utilBalancing";
export var selectBalancingContractRewards = function () { return utilBalancing.getBalancing().ContractRewards; };
export var selectBalancingContractRewardsById = memoize(function (id) {
    return selectBalancingContractRewards().get(id);
});
export var balancingContractRewardsMemoizedFunctions = [
    selectBalancingContractRewards,
    selectBalancingContractRewardsById,
];



//////////////////
// WEBPACK FOOTER
// ./src/balancingSelectors/selectBalancingContractRewards.ts
// module id = 672
// module chunks = 3